import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { useIntl } from "react-intl";
import { Grid, FormControl, TextField, MenuItem } from "@material-ui/core";
import { messages } from "../messages";
export const BuyoutDateDisplay = ({ contract }) => {
    const intl = useIntl();
    const { setFieldValue, values } = useFormikContext();
    if (!contract.buyoutDates || contract.buyoutDates.length === 0) {
        return null;
    }
    const handleDateChange = (event) => {
        setFieldValue("buyoutDate", event.target.value);
    };
    return (_jsx(Grid, { item: true, xs: 12, sm: 6, children: _jsx(FormControl, { variant: "outlined", fullWidth: true, margin: "normal", children: _jsx(TextField, { select: true, label: intl.formatMessage(messages.buyoutDate), value: values.buyoutDate, onChange: handleDateChange, helperText: " ", InputLabelProps: { shrink: true }, children: contract.buyoutDates.map((date, index) => (_jsx(MenuItem, { value: date.toISOString(), children: date.toLocaleDateString(intl.locale) }, index))) }) }) }));
};
//# sourceMappingURL=BuyoutDateDisplay.js.map